import React from 'react';
import { Table, Tag, Button, Space, Tooltip, Typography, Grid, Dropdown } from 'antd';
import { EyeOutlined, PrinterOutlined, FilePdfOutlined, RollbackOutlined, MoreOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const { Text } = Typography;
const { useBreakpoint } = Grid;

const TablaHistorialVentas = ({ 
    ventasFiltradas, 
    isLoading, 
    abrirDetalles, 
    manejarImpresionTirilla, 
    descargarPDFFormal, 
    abrirModalDevolucion 
}) => {
    
    const screens = useBreakpoint();
    const isMobile = !screens.md;

    const columnasVentas = [
        {
            title: 'Fecha y Hora',
            dataIndex: 'fecha',
            key: 'fecha',
            width: '12%',
            render: (text) => <Text>{dayjs(text).format('DD/MM/YYYY hh:mm A')}</Text>,
        },
        {
            title: 'Factura',
            dataIndex: 'numero_factura',
            key: 'numero_factura',
            width: '8%',
            render: (text) => <Text strong>{text}</Text>,
        },
        {
            title: 'Cliente',
            key: 'cliente',
            width: '12%',
            render: (_, record) => record.cliente_nombre ? <Text>{record.cliente_nombre} {record.cliente_apellidos || ''}</Text> : <Text type="secondary">Consumidor Final</Text>
        },
        {
            title: 'Usuario',
            key: 'usuario',
            width: '12%',
            render: (_, record) => <Text type="secondary">{record.cajero_nombre} {record.cajero_apellidos || ''}</Text>
        },
        {
            title: 'Total',
            dataIndex: 'total',
            key: 'total',
            width: '8%',
            render: (val) => <Text strong>${Number(val).toLocaleString('es-CO')}</Text>,
        },
        {
            title: 'Método',
            dataIndex: 'metodo_pago',
            key: 'metodo_pago',
            width: '10%',
            render: (metodo) => {
                let color = 'default';
                const m = (metodo || '').toLowerCase();
                if (m === 'efectivo') color = 'green';
                else if (m === 'transferencia' || m === 'nequi') color = 'blue';
                else if (m === 'mixto') color = 'purple';
                else if (m === 'credito') color = 'orange';
                return <Tag color={color} style={{ fontWeight: '600' }}>{metodo?.toUpperCase()}</Tag>;
            }
        },
        {
            title: 'Estado',
            key: 'estado',
            width: '10%',
            render: (_, record) => {
                if (record.status_pago === 'pagado') return <Tag color="success">PAGADO</Tag>;
                if (record.status_pago === 'pendiente') return <Tag color="warning">CRÉDITO</Tag>;
                return <Tag color="default">{record.status_pago}</Tag>;
            }
        },
        {
            title: 'Acciones',
            key: 'acciones',
            align: 'left',
            width: '14%',
            render: (_, record) => {
                const yaFueDevueltaTotalmente = record.items?.every(item => (item.cantidad_devuelta || 0) >= item.cantidad);

                const opcionesExtra = [
                    {
                        key: 'detalles',
                        label: 'Ver Detalles',
                        icon: <EyeOutlined />,
                        onClick: () => abrirDetalles(record, 'venta')
                    },
                    {
                        key: 'imprimir',
                        label: 'Imprimir Tirilla',
                        icon: <PrinterOutlined style={{ color: '#22BABB' }} />,
                        onClick: () => manejarImpresionTirilla(record)
                    },
                    {
                        key: 'pdf',
                        label: 'Descargar PDF',
                        icon: <FilePdfOutlined style={{ color: '#d32f2f' }} />,
                        onClick: () => descargarPDFFormal(record, 'venta')
                    }
                ];

                return (
                    <Space size="small">
                        <Button
                            type="primary"
                            danger
                            icon={<RollbackOutlined />}
                            onClick={() => abrirModalDevolucion(record)}
                            style={{ borderRadius: '6px' }}
                            disabled={yaFueDevueltaTotalmente}
                            title={yaFueDevueltaTotalmente ? "Factura devuelta totalmente" : "Devolver"}
                        >
                            Devolver
                        </Button>
                        <Dropdown menu={{ items: opcionesExtra }} trigger={['click']} placement="bottomRight">
                            <Button 
                                icon={<MoreOutlined style={{ fontSize: '18px', color: '#475569' }} />} 
                                style={{ 
                                    borderRadius: '6px', 
                                    backgroundColor: '#f1f5f9', 
                                    borderColor: '#cbd5e1' 
                                }} 
                                title="Más opciones"
                            />
                        </Dropdown>
                    </Space>
                );
            }
        }
    ];

    return (
        <div style={{ flex: 1, minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            <Table
                columns={columnasVentas}
                dataSource={ventasFiltradas}
                rowKey="id"
                loading={isLoading}
                scroll={{ x: 'max-content', y: isMobile ? 'calc(100vh - 490px)' : 'calc(100vh - 350px)' }}
                pagination={{ pageSize: 50, showSizeChanger: false }}
                style={{ flex: 1 }}
            />
        </div>
    );
};

export default TablaHistorialVentas;